import { useField } from "formik";
import { useCallback, useEffect, useRef } from "react";
import { useAddRemoveMachines } from "./useAddRemoveMachines";


/** Keeps the sf_area last value selected by user */
// export const usePlatformSelection = () => {
//     const [{ value: platforms }, , { setValue }] = useField<any[]>("platform_list");
//     const { removeByPlatformIds } = useAddRemoveMachines();

//     // ✅ store previous sf_area values
//     const previousSfAreaRef = useRef<Record<string, number>>({});

//     const addPlatform = useCallback((id: string) => {
//         const existing = platforms || [];

//         const previousValue = previousSfAreaRef.current[id];

//         setValue([
//             ...existing,
//             {
//                 id,
//                 sf_area: previousValue ?? 0 // ✅ restore old value if exists
//             }
//         ]);
//     }, [platforms, setValue]);

//     const removePlatform = useCallback((id: string) => {
//         const existing = platforms || [];

//         const platformToRemove = existing.find((f) => f.id === id);

//         // ✅ save sf_area before removing
//         if (platformToRemove) {
//             previousSfAreaRef.current[id] = platformToRemove.sf_area;
//         }

//         setValue(existing.filter((p) => p.id !== id));

//         removeByPlatformIds([id]);
//     }, [platforms, setValue, removeByPlatformIds]);

//     const updateSfArea = useCallback((id: string, value: number) => {
//         const updated = (platforms || []).map((p) =>
//             p.id === id ? { ...p, sf_area: value } : p
//         );

//         // ✅ keep memory updated
//         previousSfAreaRef.current[id] = value;

//         setValue(updated);
//     }, [platforms, setValue]);

//     return {
//         platforms: platforms || [],
//         addPlatform,
//         removePlatform,
//         updateSfArea
//     };
// };

/** keeps last value that was coming from api response */
// export const usePlatformSelection = () => {
//     const [{ value: platforms }, , { setValue }] = useField<any[]>("platform_list");
//     const { removeByPlatformIds } = useAddRemoveMachines();

//     //  store INITIAL API values only once
//     const initialSfAreaRef = useRef<Record<string, number>>({});

//     //  capture initial values only on first render
//     useEffect(() => {
//         if (platforms?.length) {
//             platforms.forEach((f) => {
//                 if (f.id && initialSfAreaRef.current[f.id] === undefined) {
//                     initialSfAreaRef.current[f.id] = f.sf_area;
//                 }
//             });
//         }
//     }, []); //  ONLY ON MOUNT

//     const addPlatform = useCallback((id: string) => {
//         const existing = platforms || [];

//         if (existing.some(f => f.id === id)) return;

//         const initialValue = initialSfAreaRef.current[id];

//         setValue([
//             ...existing,
//             {
//                 id,
//                 sf_area: initialValue ?? 0 //  restore API value
//             }
//         ]);
//     }, [platforms, setValue]);

//     const removePlatform = useCallback((id: string) => {
//         debugger;
//         console.log("debugger Removing platform with id: " + id);


//         console.log("debugger Filtered platforms: ", (platforms || []).filter((p) => p.id !== id));
//         debugger;
//         setValue((platforms || []).filter((p) => p.id !== id));

//         //removeByPlatformIds([id]);
//     }, [platforms, setValue, removeByPlatformIds]);

//     const updateSfArea = useCallback((id: string, value: number) => {
//         const updated = (platforms || []).map((p) =>
//             p.id === id ? { ...p, sf_area: value } : p
//         );
//         setValue(updated);
//     }, [platforms, setValue]);

//     return {
//         platforms: platforms || [],
//         addPlatform,
//         removePlatform,
//         updateSfArea
//     };
// };


export const usePlatformSelection = () => {
    const [{ value: platforms }, , { setValue }] = useField<any[]>("platform_list");
    const { removeByPlatformIds } = useAddRemoveMachines();
    const initialSfAreaRef = useRef<Record<string, number>>({});

    // 1. Stable Initial Capture: Only runs once on mount.
    useEffect(() => {
        if (platforms?.length) {
            platforms.forEach((f) => {
                if (f.id && initialSfAreaRef.current[f.id] === undefined) {
                    initialSfAreaRef.current[f.id] = f.sf_area;
                }
            });
        }
    }, []);

    // 2. Optimized Bulk Add
    const addPlatforms = useCallback((ids: string | string[]) => {
        const idsToAdd = Array.isArray(ids) ? ids : [ids];
        const currentPlatforms = platforms || [];

        const newIds = idsToAdd.filter(id => !currentPlatforms.some(f => f.id === id));

        if (newIds.length === 0) return; // Prevents unnecessary re-renders

        const newEntries = newIds.map(id => ({
            id,
            //   sf_area: initialSfAreaRef.current[id] ?? 0
            sf_area: 0
        }));

        setValue([...currentPlatforms, ...newEntries]);
    }, [platforms, setValue]);

    // 3. Optimized Bulk Remove
    const removePlatforms = useCallback((ids: string | string[]) => {
        const idsToRemove = Array.isArray(ids) ? ids : [ids];
        const currentPlatforms = platforms || [];

        const updated = currentPlatforms.filter((f) => !idsToRemove.includes(f.id));

        // Only update if something actually changed
        if (updated.length !== currentPlatforms.length) {
            setValue(updated);
            removeByPlatformIds(idsToRemove);
        }
    }, [platforms, setValue, removeByPlatformIds]);

    const updateSfArea = useCallback((id: string, value: number) => {
        const currentPlatforms = platforms || [];
        const updated = currentPlatforms.map((p) =>
            p.id === id ? { ...p, sf_area: value } : p
        );
        setValue(updated);
    }, [platforms, setValue]);

    return {
        platforms: platforms || [],
        addPlatforms,
        removePlatforms,
        updateSfArea
    };
};